import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsTable from "./en-us/table.json";

export const localizationEnUsPaymentMethods = {
  ...localizationEnUsHeader,
  ...localizationEnUsTable,
};
